const CSS = () => `
    html.locked,
    html.locked body {
        overflow: hidden;
    }
`;

function preventTouchMove(e) {
    e.stopPropagation();
    e.preventDefault();
}

function disableScrolling (element) {
    element.classList.add('locked');
    element.addEventListener('touchmove', preventTouchMove, { passive: false });
}
function enableScrolling (element) {
    element.classList.remove('locked');
    element.removeEventListener('touchmove', preventTouchMove);
}

/**
 * This feature is used to disable and enable scrolling
 * 
 * @class Scrolling
 */

export default class Scrolling {
    constructor () {
        if (!document.documentElement) {
            throw new Error('Document element does not exist');
        }

        this.document = document.documentElement;

        const head = document.head || document.querySelector('head');
        this.head = head || null;

        this.setStyles();
    }

    setStyles () {
        if (!this.head) return;

        const style = document.createElement('style');
        style.setAttribute('id', 'site-scrolling-css');
        style.type = 'text/css';

        if (style.styleSheet){
            style.styleSheet.cssText = CSS(this.query);
        } else {
            style.appendChild(document.createTextNode(CSS(this.query)));
        }

        this.head.append(style);
    }

    disable () {
        disableScrolling(this.document);
    }

    enable () {
        enableScrolling(this.document);
    }
}

/**
 * Usage example
 * 
 * import Scrolling from 'utils/class/scrolling';
 * 
 * const scrolling = new Scrolling();
 * 
 * scrolling.disable();
 * scrolling.enable();
 * 
 */
